// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"d99b7a4d","209":"f91d1330","398":"11f9b6c7","787":"dcde9b11"}[chunkId] + ".chunk.js";
};